export default {
    admin: {
        title: "Administración",
        futureScreen: "Pantalla de futuro",
        freqMappings: {
            title: "Mapeos de frecuencia",
            frequency: "Frecuencia (MHz)",
            name: "Nombre",
            addRow: "Añadir fila",
            deleteSelectedRows: "Eliminar filas seleccionadas",
            refresh: "Actualizar al servidor",
            nameRuleRequired: "Se requiere el nombre",
            nameRuleUnique: "El nombre no debe estar asignado actualmente",
            freqRuleRequired: "Se requiere frecuencia",
            freqRuleNumberMultiple: "La frecuencia debe ser múltiplo de 6250 Hz",
            freqRuleMin: "La frecuencia debe ser mayor o igual que 409.6 MHz",
            freqRuleUnique: "La frecuencia no debe estar asignada actualmente",
            frequencyAlreadyMapped: "La frecuencia '{frequency}' ya está asignada",
            frequencyNameAlreadyMapped: "El nombre de frecuencia '{name}' ya está asignado a otra frecuencia",
            frequencyNotMultiple: 'Frecuencia no válida: la frecuencia debe ser un múltiplo de 6250 Hz',
            freqRuleMHz: "Frecuencia es demasiado grande, ingrese en MHz",
            mappingDeleted: "Mapeo eliminado",
            mappingDeletedError: "Error al eliminar la asignación",
            mappingSaved: "Mapeo guardado",
            mappingSavedError: "Error al guardar la asignación",
            mappingUpdated: "Mapeo actualizado",
            mappingUpdatedError: "Error al actualizar el mapeo",
            noRowsToShow: "No hay filas para mostrar",
            mappingIncompleteError: "La asignación era inválida o faltaban valores, no se pudo guardar"
        },
        ncsManagementTab:{
            title: "Gestión NCS",
            primary:"Primaria",
            secondary:"Secundario",
            null:"No establecido"
        },
        btsManagementTab:{
            title:"Gestión de configuración de la estación base",
            description: "Cambiar la forma en que NCS gestiona la configuración de las torres",
        },
        currentInstance:{
            title:"Rol actual",
            discription:"Función actual de gestión de la estación base",
            fetchError:"Se produjo un error al obtener la función de administración de la estación base actual",
            change:{
                title:"Cambiar la función de gestión de la estación base",
                msg:"Confirme que desea cambiar esta instancia de NCS a {msg}",
                error:"No se pudo cambiar la función de administración de la estación base a {msg}",
                success:"Función de gestión de estación base actualizada"
            }
        },
        altCertsUrl:{
            title:"URL de clave pública de CA alternativa",
            description: "URL para verificación de certificados",
            fetchError:"Se produjo un error mientras se encontraba la URL de clave pública de CA alternativa",
            change:{
                title:"Ingrese la URL del certificado alternativo",
                confirmTitle:"Ingrese la URL de clave pública de CA alternativa",
                msg:"Confirme que desea cambiar la URL de clave pública de CA alternativa a {msg}",
                error:"No se pudo cambiar la URL de clave pública de CA alternativa a {msg}",
                success:"URL de clave pública de CA alternativa actualizada"
            }
        },
        outboundManagement: {
            bulkActions: {
                confirmation: {
                    title: "Confirmar Acción Masiva",
                    message: "¿Estás seguro de que deseas {mode}?"
                },
                ENABLED: {
                    button: "Habilitar Todo",
                },
                DISABLED: {
                    button: "Deshabilitar Todo",
                },
                ENABLED_READ_ONLY: {
                    button: "Establecer todos como solo lectura",
                }
            },            
            netTuneTitle: "Gestión de NetTune",
            netConfigTitle: "Gestión de NetConfig",
            featureModes: {
                statusDropdown: {
                    title: "Estado del tráfico saliente",
                    subtitle: "Funciones que interactúan con los puntos finales en todo el sistema.",
                    btn: "Administrar tráfico saliente",
                    noFeatures: "No hay características {status}.",
                },
                selectiveEnabled: "Habilitado selectivamente",
                features: "Características",
                readOnly: "Solo Lectura",
                enabled: "Habilitado",
                disabled: "Deshabilitado",
                enabled_read_only: "Solo Lectura",
                mode: "Modo",
                selectValidationError: "{feature} no puede ser {featureVal} cuando {featureDep} es {depVal}.",
                USER_COMMANDS_NETCONFIG: {
                    title: "Comandos de usuario para la configuración de la estación base",
                    description: "Administrar la infraestructura de comandos que se envían a las estaciones base."
                },
                SPR_RAPID_TUNE: {
                    title: "Sintonización rápida",
                    description: "Una función que evalúa rápidamente los puntos finales recién descubiertos (generalmente recién instalados) y los mueve del canal administrativo a pares de canales a granel disponibles.",
                },
                ETL: {
                    title: "ETL",
                    description: "Extraiga los datos de la estación base de NCS, transforme y cargue esos datos en la tabla RNI DB dim_tgb y tower_channels",
                },
                USER_COMMANDS: {
                    title: "Comandos de usuario para puntos finales",
                    description: "Administrar la capacidad de un usuario para enviar manualmente comandos de configuración o ping a un punto final.",
                },
                TUNING_CHAIN_TUNING_CB: {
                    title: "Balanceo de Canales",
                    description: "El balanceo de canales es un proceso iterativo de mover endpoints entre canales."
                },
                TUNING_CHAIN_BUDDY_CONFIG: {
                    title: "Configuración de Compañero de Ajuste",
                    description: "Configuraciones vitales de compañeros de cadena de ajuste, retransmisores estáticos, etc."
                },
                TUNING_CHAIN_BUDDY_DIST: {
                    title: "Distribución de Compañeros de Ajuste",
                    description: "Parte del trabajo de la cadena de tuning. Garantiza que en un hexágono determinado con un radio de 0,5 millas, al menos un amigo esté en el canal de administración."
                },
                TUNING_CHAIN_TUNING_NCO: {
                    title: "Optimización de Capacidad de Red",
                    description: "NCO utiliza el motor de reglas para ejecutar reglas definidas por el cliente y determinar la configuración de ajuste."
                },
                SPR_LATENT_TOWER_SS_REPORT_PINGER: {
                    title: "Pinger de reporte de intensidad de señal de estación base latente",
                    description: "Monitorea y envía pings cuando no se recibe un informe completo de intensidad de señal de estación base desde un punto final durante el período de tiempo de latencia mínima."
                },
                SPR_LATENT_ORD_PINGER: {
                    title: "Pinger ORD latente",
                    description: "Monitorea y envía pings cuando no se recibe un informe de intensidad de señal ORD desde un punto final durante el período de tiempo de latencia mínima."
                },
                PINGERS: {
                    title: "Configuración de Pingers",
                    description: "Configura y administra el comportamiento de monitoreo y ping, incluido el Pinger de reporte de intensidad de señal de estación base latente y el Pinger ORD latente, en respuesta a informes de intensidad de señal faltantes de los puntos finales."
                }
            },
        },
        netTuneConfiguration: {
            searchPlaceholder: "Buscar por Características o Configuraciones",
            description: "Ajustar finamente las características y servicios que componen NetTune.",
            resetDefaults: "Restablecer a Valores Predeterminados",
            saveChanges: "Guardar Cambios"
        }
    }
}
